import React, { useEffect, useMemo, useRef } from "react";
import { BasicUserInfo, Student } from "../../../../../../../store/onboarding/types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type OwnProps = {
  onClick: () => any;
  selectedStudents: Array<Student>;
};

type Props = OwnProps;

const CheckTeacherClassHeaderCell: React.FunctionComponent<Props> = (props) => {
  const hasSelectedStudents = props.selectedStudents.length > 0;

  let [uniqueGrade, setUniqueGrade] = React.useState<Array<string>>([]);

  useEffect(() => {
    setUniqueGrade(
      Array.from(
        new Set(
          props.selectedStudents
            .map((student) => student.grade)
            .filter((grade): grade is string => grade !== undefined)
        )
      ));
  }, [props.selectedStudents]);

  let hasSelectedStudentsCommonTeacher: boolean = useMemo(() => {
    let hasSelectedStudentsCommonTeacherLocal = false;
    let uniqueTeachers: number[] = Array.from(new Set(props.selectedStudents
      .map(item => item.teachers!)
      .reduce((prev, curr) => prev.concat(curr), [])
      .filter((item, i, arr) => arr.indexOf(item) === i)
      .map((data: BasicUserInfo) => data.id!)));

    let uniqueTeacherCountArray: { id: number; count: number }[] = [];
    for (let i = 0; i < uniqueTeachers.length; i++) {
      const element = {
        id: uniqueTeachers[i],
        count: 0
      };
      uniqueTeacherCountArray.push(element);
    }

    for (let i = 0; i < props.selectedStudents.length; i++) {
      const student = props.selectedStudents[i];
      for (let j = 0; j < uniqueTeacherCountArray.length; j++) {
        if (student.teachers?.filter((teacher) => teacher.id == uniqueTeacherCountArray[j].id).length) {
          uniqueTeacherCountArray[j].count = uniqueTeacherCountArray[j].count + 1;

        }
      }
    }

    for (let k = 0; k < uniqueTeacherCountArray.length; k++) {
      if (uniqueTeacherCountArray[k]['count'] == props.selectedStudents.length) {
        hasSelectedStudentsCommonTeacherLocal = true;
        break;
      }
    }
      return hasSelectedStudentsCommonTeacherLocal;
  }, [props.selectedStudents]);

  const hasSameGrade = useMemo(() => uniqueGrade.length === 1, [uniqueGrade]);
  
  const isValid = useMemo(() => 
    hasSelectedStudents && hasSameGrade && hasSelectedStudentsCommonTeacher
  , [hasSelectedStudents, hasSameGrade, hasSelectedStudentsCommonTeacher]);

  const getTooltipText = useMemo(() => {
    if (!hasSelectedStudents) {
      return "Select students to assign a teacher’s class";
    }
    if (!hasSameGrade && !hasSelectedStudentsCommonTeacher) {
      return "Select students with the same grade and teacher";
    }
    if (!hasSameGrade) {
      return "Select students with the same grade";
    }
    if (!hasSelectedStudentsCommonTeacher) {
      return "Select students with the same teacher";
    }
    return "Assign teacher’s class to selected students";
  }, [hasSelectedStudents, hasSameGrade, hasSelectedStudentsCommonTeacher]);
  
  return (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="assign-teacher-tooltip">
              {getTooltipText}
            </Tooltip>
          }
        >
          <div>
            <button
              className="blueBtnSm"
              onClick={props.onClick}
              style={{ margin: "auto" }}
              disabled={!isValid}
            >
              Assign Teacher's Class
            </button>
          </div>
        </OverlayTrigger>
  );
};

export default CheckTeacherClassHeaderCell;
